export default "__VITE_ASSET__1bd48ae8__"